import { FeatureDialogService } from '../components/feature-dialog-launcher/feature-dialog-launcher.service';
import { RecaptchaService } from './recaptcha/recaptcha-service';

export * from './util';

export default function() {
    const win = (typeof (window as any) !== 'undefined' ? window : {}) as any;
    if (!win.com) { win.com = {}; }
    if (!win.com.TI) { win.com.TI = {}; }
    if (!win.com.TI.FeatureDialogService) { win.com.TI.FeatureDialogService = FeatureDialogService; }
    if (!win.com.TI.RecaptchaService) {
        win.com.TI.RecaptchaService = RecaptchaService;
        document.dispatchEvent(new CustomEvent('tiRecaptchaServiceReady', { bubbles: true }));
    }
}
